import React, { useMemo, useState } from 'react';
import { WhatHappenedSection as WhatHappenedSectionType } from '../../../../../types/case-workspace';
import { parseDecisionReferences } from '../../../../../utils/decisionLinks';
import ReportSectionHeading from './ReportSectionHeading';

interface WhatHappenedSectionProps {
  events: WhatHappenedSectionType;
  onDecisionClick?: (decisionIdOrReference: string) => void;
}

const WhatHappenedSection: React.FC<WhatHappenedSectionProps> = ({ events, onDecisionClick }) => {
  const [expanded, setExpanded] = useState(false);
  const visibleEvents = useMemo(
    () => (expanded ? events.events : events.events.slice(0, 3)),
    [events.events, expanded]
  );
  const hiddenCount = Math.max(0, events.events.length - 3);

  const renderEventWithLinks = (event: string, index: number) => {
    const segments = parseDecisionReferences(event);

    return (
      <div key={index} className="relative border-l-2 border-border pb-5 pl-5 last:pb-0">
        <div className="absolute -left-[5px] top-1 h-2 w-2 rounded-full bg-primary" />
        <p className="text-[13px] leading-[1.7] text-foreground">
              {segments.map((segment, segIndex) => {
                if (segment.isReference && segment.reference && onDecisionClick) {
                  return (
                    <button
                      key={segIndex}
                      onClick={() => onDecisionClick(segment.reference!)}
                      className="text-primary hover:underline cursor-pointer font-medium"
                    >
                      {segment.text}
                    </button>
                  );
                } else if (segment.isReference && segment.reference) {
                  return (
                    <a
                      key={segIndex}
                      href={`#precedent-${segment.reference}`}
                      className="text-primary hover:underline"
                    >
                      {segment.text}
                    </a>
                  );
                }
                return <span key={segIndex}>{segment.text}</span>;
              })}
        </p>
      </div>
    );
  };

  return (
    <section className="border-b border-border px-6 py-5">
      <ReportSectionHeading number={2} title="Timeline" className="mb-4" />

      <div className="space-y-1">
        {visibleEvents.map((event, index) => renderEventWithLinks(event, index))}
      </div>

      {hiddenCount > 0 && (
        <button
          type="button"
          onClick={() => setExpanded((value) => !value)}
          className="mt-4 text-[12px] font-medium text-primary transition-colors hover:text-primary/80"
        >
          {expanded ? 'Show less' : `Show ${hiddenCount} more`} {expanded ? '↑' : '↓'}
        </button>
      )}
    </section>
  );
};

export default WhatHappenedSection;
